import React, { createContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

export const CarrierContext = createContext();

export const CarrierProvider = ({ children }) => {
  const [carrier, setCarrier] = useState("");
  const [isValidCarrier, setIsValidCarrier] = useState(null);

  useEffect(() => {
    const path = window.location.pathname.substring(1);

    const carrierInURL = path.split("/")[0];
    const allowedValues = [
      "christus",
      "bcbsaz",
      "mountain_health",
    ];
    /*const allowedValues = ["christus"];*/

    setIsValidCarrier(allowedValues.includes(carrierInURL));

    if (isValidCarrier) {
      setCarrier(carrierInURL);
    } else {
      const notFound = "/" + carrier + "notfound";
      <Navigate to={`${notFound}`} />;
    }
  }, [isValidCarrier, carrier]);

  const value = { carrier, isValidCarrier };

  return (
    <CarrierContext.Provider value={value}>{children}</CarrierContext.Provider>
  );
};
